import React, { useState } from 'react';
import { Button } from 'flowbite-react';
import { MdUploadFile } from 'react-icons/md';
import { useCSVReader } from 'react-papaparse';
import { HiUpload } from 'react-icons/hi';
import AddUsersConfirmationModal from './LeadsGen/AddUsersConfirmationModal';

interface Props {
	title?: string;
	handleSubmit: (data: Record<string, string>[]) => void;
	showIcon?: boolean;
	color?: string;
	header?: string;
}

const UploadCsv: React.FC<Props> = ({ title, handleSubmit, showIcon, color = 'purplePlaced', header }) => {
	const [keys, setKeys] = useState<string[]>([]);
	const [rows, setRows] = useState<Array<Record<string, string>>>([]);
	const { CSVReader } = useCSVReader();
	const [isOpen, setIsOpenModal] = useState<boolean>(false);
	const handleCSVUpload = (results: { data: Array<Array<string>> }): void => {
		let [keys, ...valueArray] = results.data;
		setKeys(keys);

		let data = valueArray
			.filter(row => row.length > 0)
			.map((row: string[]) => {
				return keys.reduce((acc: Record<string, string>, key: string, index: number) => {
					acc[key] = row[index];
					return acc;
				}, {});
			});
		setRows(data);
		setIsOpenModal(true);
	};

	return (
		<div>
			<CSVReader onUploadAccepted={handleCSVUpload}>
				{({ getRootProps }: any) => (
					<Button color={color} type="submit" onClick={() => setRows([])} {...getRootProps()}>
						{showIcon ? (
							<HiUpload size="20px" />
						) : (
							<>
								<MdUploadFile className="mr-2" />
								{title ?? 'Upload CSV'}
							</>
						)}
					</Button>
				)}
			</CSVReader>
			<AddUsersConfirmationModal
				isOpen={isOpen}
				onClose={() => setIsOpenModal(false)}
				keys={keys}
				data={rows}
				header={header}
				handleSubmit={(data) => handleSubmit(data)}
			/>
		</div>
	);
};

export default UploadCsv;
